import DOMPurify from 'isomorphic-dompurify';
import MarkdownIt from 'markdown-it';
import { Label } from 'semantic-ui-react';

import s from '../../../json-field-editor.scss';
import type { CustomMessagePreviewProps } from '../types';

// Initialize the Markdown renderer
const md = new MarkdownIt({
  breaks: true,
  linkify: true,
});

/**
 * Custom Message preview component to show what the custom message will look
 * like (including Markdown rendering)
 */
const CustomMessagePreview = ({ formData }: CustomMessagePreviewProps) => {
  if (!formData || typeof formData !== 'object') return null;

  const { title, message } = formData;
  const hasTitle = title?.trim();
  const hasMessage = message?.trim();

  if (!hasTitle && !hasMessage) return null;

  return (
    <div className={s.customMessagePreview}>
      <h4 className={s.customMessagePreviewTitle}>Preview</h4>
      <div className={s.customMessagePreviewItem}>
        <Label attached="top" size="small">
          Custom Message—Login View
        </Label>
        <div className={s.customMessageContent}>
          {hasTitle && (
            <h4
              className={s.customMessageTitle}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: md.renderInline(DOMPurify.sanitize(title)),
              }}
            />
          )}
          {hasMessage && (
            <div
              className={s.customMessageBody}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: md.render(DOMPurify.sanitize(message)),
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomMessagePreview;
